export default __webpack_public_path__ + "static/media/BYD T38424.beb477bd.jpg";